import {MediaMatcher} from '@angular/cdk/layout';
import {AfterViewInit, ChangeDetectorRef, Component, HostListener, OnInit, ViewChild} from '@angular/core';
import {FormControl} from '@angular/forms';
import {MatSidenav} from '@angular/material/sidenav';
import {Title} from '@angular/platform-browser';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {CookieService} from 'ngx-cookie-service';
import {BehaviorSubject, take} from 'rxjs';
import {AuthService} from '../auth.service';
import {Role} from '../models/role';
import {Tenant} from '../models/tenant';
import {UnreadMessages} from '../models/unreadMessages';
import {User} from '../models/user';
import {style} from '@angular/animations';
import { NgxSpinnerService } from 'ngx-spinner';
import {ThemePalette} from '@angular/material/core';
import {ProgressSpinnerMode} from '@angular/material/progress-spinner';
import { ManagementService } from '../services/management.service';
import { Base } from '../services/base';
import {GoogleMap} from '@angular/google-maps';
import {authState, user} from '@angular/fire/auth';
import { TenantService } from '../services/tenant.service';
import { TenantFarmBoundsService } from '../tenant-view/tenant-view-services/tenant-farm-bounds.service';
import { Database, ref, onValue } from '@angular/fire/database';
import { environment } from "src/environments/environment";
import {filter} from "rxjs/operators";

interface SideNavRoute {
  icon?: string;
  route?: string;
  title?: string;
}

@Component({
    selector: 'app-navbar',
    templateUrl: './nav-bar.component.html',
    styleUrls: ['./nav-bar.component.css'],
    standalone: false
})
export class NavBarComponent implements OnInit, AfterViewInit {

  options = {autoHide: false, scrollbarMinSize: 100};

  mobileQuery: MediaQueryList;

  public showProfileMenu: boolean = true;

  private _mobileQueryListener: () => void;
  public mainRoutes: SideNavRoute[] = [];
  sideBarOpened: boolean = false;

  public profilePic: string;
  public name: string;

  public email: string;
  public password: string;
  public page: string;
  userInitials: string = '';

  public tenants: Tenant[];
  public roles: Role[];

  public tenantIdSubject = new BehaviorSubject<number>(null);
  tenantId$ = this.tenantIdSubject.asObservable();

  selectedTenantId: string | null = null;

  public tenantId: number;
  public isLoading = false;
  public clearSearch = true;
  showProfileDialog: boolean = false;

  public unreadInspections = 0;

  public dashboard;
  public mapAnalysis;
  public fieldAdmin;
  public priorityGroups;

  public environment = environment;
  private soilIqUrl = environment.soilIqUrl;

  public enableMenu: boolean = true;

  isSelectVisible: boolean = false;

  searchTenants = "Search..";
  noResults = "No matching tenants found"

  tenantCtrl = new FormControl();
  filteredTenants: Tenant[];
  showNavComponents: boolean = false;

  @ViewChild('snav') sidenav: MatSidenav;
  private _snackBar: any;

  constructor(public auth: AuthService,
              changeDetectorRef: ChangeDetectorRef,
              public base: Base,
              public managementService: ManagementService,
              media: MediaMatcher,
              private db: Database,
              public cookieService: CookieService,
              public translate: TranslateService,
              public router: Router,
              public route: ActivatedRoute,
              public projectTitle: Title,
              private spinner: NgxSpinnerService,
              private tenantService: TenantService,
              private tenantFarmBoundsService: TenantFarmBoundsService
  ) {

    router.events.subscribe((event) => {
      if(event instanceof NavigationEnd) {
              this.showNavComponents = !['registration', 'forgot-password', 'activation', '', 'login'].includes(event.url.split('/')[1]);
            }
    })
    document.addEventListener('mousedown', (e: any) => {
      let profileDialog = document.getElementById('profile-dialog');
      let profileButton = document.getElementById('profile-button');

      if(profileButton?.contains(e.target)) {
        this.showProfileDialog = !this.showProfileDialog;
      } else if(!profileDialog?.contains(e.target)) {
        this.showProfileDialog = false;
      }
    })

    // this.loadNavListItems();

    this.translate.addLangs(['en', 'fr', 'es']);

    if (this.cookieService.get('default-language') != '') {
      this.translate.setDefaultLang(this.cookieService.get('default-language'));
    } else {
      const browserLang = this.translate.getBrowserLang();
      this.translate.use(browserLang.match(/en|es|tr/) ? browserLang : 'en');
    }

    this.mobileQuery = media.matchMedia('(max-width: 600px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);

    this.auth.userProfile$.subscribe((profile) => {
      if (profile != null) {
        this.profilePic = profile.picture;
      }
    });

    // if (sessionStorage.getItem("user")) {
    //   let user: User = JSON.parse(sessionStorage.getItem('user'));
    //   this.name = user.name + ' ' + user.surname;
    //   this.userInitials = user.name[0] + user.surname[0];
    //   this.email = user.email;
    // } else {
    //   this.auth.user$.subscribe((user) => {
    //     if (user) {
    //       this.name = user.name + ' ' + user.surname;
    //       this.userInitials = user.name[0] + user.surname[0];
    //       this.email = user.email;
    //
    //       authState(this.auth.auth).subscribe(authenticated => {
    //         if (authenticated) {
    //           const userNotificationsRef = ref(this.db, `user_notifications/${user.id}`);
    //           onValue(userNotificationsRef, (snapshot) => {
    //             this.unreadInspections = 0;
    //             const data = snapshot.val();
    //             if (data) {
    //               Object.values(data).forEach((unreadMessage: UnreadMessages) => {
    //                 if (unreadMessage.unreadMessages != null) {
    //                   this.unreadInspections += unreadMessage.unreadMessages;
    //                 }
    //               });
    //             }
    //           });
    //         }
    //       })
    //     }
    //   })
    // }

    this.auth.user$.pipe(
        filter(user => user != null),
        take(1)
    ).subscribe(user => {
      this.name = user.name + ' ' + user.surname;
      this.userInitials = user.name[0] + user.surname[0];
      this.email = user.email;
      sessionStorage.setItem("user", JSON.stringify(user));

          authState(this.auth.auth).subscribe(authenticated => {
            if (authenticated) {
              const userNotificationsRef = ref(this.db, `user_notifications/${user.id}`);
              onValue(userNotificationsRef, (snapshot) => {
                this.unreadInspections = 0;
                const data = snapshot.val();
                if (data) {
                  Object.values(data).forEach((unreadMessage: UnreadMessages) => {
                    if (unreadMessage.unreadMessages != null) {
                      this.unreadInspections += unreadMessage.unreadMessages;
                    }
                  });
                }
              });
            }
          })
        })

    if (sessionStorage.getItem("tenants")) {
      this.tenants = JSON.parse(sessionStorage.getItem('tenants'));
      this.filteredTenants = JSON.parse(sessionStorage.getItem('tenants'));

      if(!sessionStorage.getItem("selectedTenant")) {
        this.tenants.forEach(tenant => {
          if (tenant.isHomeTenant) {
            sessionStorage.setItem("selectedTenant", tenant.id.toString());
            this.tenantIdSubject.next(tenant.id);
            this.tenantId = tenant.id;
          }
        });
      }
    } else {
      this.auth.tenants$.pipe(
        filter(tenants => tenants != null),
        take(1)
      ).subscribe(tenants => {
          this.tenants = tenants;
          this.filteredTenants = tenants;
          const home = tenants.find(t => t.isHomeTenant);
          if (home) {
            sessionStorage.setItem("selectedTenant", home.id.toString());
            this.tenantIdSubject.next(home.id);
            this.tenantId = home.id;
          }
      })
    }
    if (sessionStorage.getItem("selectedTenant") != null) {
      this.tenantIdSubject.next(+sessionStorage.getItem("selectedTenant"));

      this.tenantId$.subscribe(id => {
        this.tenantId = id;
      })
    }

    // this.auth.roles$.subscribe(roles => {
    //   if (roles) {
    //     this.roles = roles;
    //   }
    // })

    this.base.hasError$.subscribe(hasError => {
      if (hasError) {
        this.isLoading = false;
      }
    });
  }

  // private _filterTenants(tenant: string): Tenant[] {
  //   const filterValue = tenant.toLowerCase();

  //   return this.tenants.filter(tenant => tenant.name.toLowerCase().indexOf(filterValue) === 0);
  // }

  onOpenedChange() {
    this.base.silenceOpen();
  }

  onClosedChange() {
    this.base.silenceClose();
  }

  toggleLoading(loading: boolean = false) {
    if (loading) {
      this.spinner.show();
      // //
    } else {
      this.spinner.hide();
      // //
    }
  }

  getIsLoading() {
    return this.isLoading;
  }

  onTenantChange(tenantId: string | null): void {

    sessionStorage.removeItem('lastFarmId');
    sessionStorage.removeItem('lastFarmName');

    this.toggleLoading(true);
    this.filteredTenants = this.tenants;
    sessionStorage.setItem("selectedTenant", this.tenantId.toString());
    this.tenantIdSubject.next(this.tenantId);

    this.selectedTenantId = tenantId;
    this.tenantService.changetenantId(tenantId);

    this.tenantFarmBoundsService.isTenantFarmLabelVisible = true;

    if(this.router.url === '/tenant-view'){
      this.toggleLoading(true);
      this.tenantFarmBoundsService.clearTeanatviewMap();
    } else{
        setTimeout(() => {
          this.toggleLoading(false);
        }, 850);
    }


  }


  async loadNavListItems(roles?: Role[]) {
    let dashboard: SideNavRoute = {
      icon: 'dashboard',
      route: '/dashboard',
      title: 'Dashboard'
    };

    let mapping: SideNavRoute = {
      icon: 'map',
      route: '/mapping',
      title: 'Map Analysis'
    }

    let priorityGroups: SideNavRoute = {
      icon: 'format_line_spacing',
      route: '/priority-groups',
      title: 'Priority Groups'
    }

    let virtualConsultant: SideNavRoute = {
      icon: 'forum',
      route: '/virtual-consultant',
      title: 'Inspections'
    }

    // var fieldAdmin: SideNavRoute = {
    //   icon: 'article',
    //   route: '/field-admin',
    //   title: 'Field Admin'
    // }

    let seasonManager: SideNavRoute = {
      icon: 'article',
      route: '/season-manager/seasons',
      title: 'Season Manager'
    }

    var orderManager: SideNavRoute = {
      icon: 'assignment',
      route: '/order-manager/my-orders',
      title: 'Order Manager'
    }

    var orderManager: SideNavRoute = {
      icon: 'assignment',
      route: '/order-manager/my-orders',
      title: 'Order Manager'
    }

    const roleList = roles ?? JSON.parse(sessionStorage.getItem('roles') || '[]');

    roleList.forEach(role => {
      if (role.name == 'AngularDashboard') {
        this.mainRoutes.push(dashboard);
      }
      if (role.name == 'AngularMapping'){
        this.mainRoutes.push(mapping);
      }
      if (role.name == 'AngularPriorityGroups') {
        this.mainRoutes.push(priorityGroups);
      }
      if (role.name == 'AngularFieldAdmin') {
        this.mainRoutes.push(seasonManager);
      }
      if (role.name == 'OTCOverallApprovingManager' || role.name == 'OTCApprovingManager' || role.name == 'OTCAgent' || role.name == 'OTCRepresentative') {
        this.mainRoutes.push(orderManager);
      }
    });

    // // } else {
    // //   this.auth.roles$.subscribe(roles => {
    // //     if (roles != null) {
    // //       roles.forEach(role => {
    // //         if (role.name == 'AngularDashboard') {
    // //           this.mainRoutes.push(dashboard);
    // //         }
    // //         if (role.name == 'AngularMapping') {
    // //           this.mainRoutes.push(mapping);
    // //         }
    // //         if (role.name == 'AngularPriorityGroups') {
    // //           this.mainRoutes.push(priorityGroups);
    // //         }
    // //         // if (role.name == 'AngularFieldAdmin') {
    // //         //   this.mainRoutes.push(fieldAdmin);
    // //         // }
    // //         if (role.name == 'AngularFieldAdmin') {
    // //           this.mainRoutes.push(seasonManager);
    // //         }
    // //         if (role.name == 'OTCOverallApprovingManager' || role.name == 'OTCApprovingManager' || role.name == 'OTCAgent' || role.name == 'OTCRepresentative') {
    // //           this.mainRoutes.push(orderManager);
    // //         }
    // //
    // //       });
    // //     }
    //   })

  }

  shouldHideTenantSelection(): boolean {
    const url = window.location.href;
    return url.includes('/order-manager') || url.includes('lab-manager') || url.includes('recommendation-manager') || url.includes('soil-preparation'); // Replace 'specificText' with the actual text you want to check for
  }

  onTenantSearch(searchString: string) {
    this.filteredTenants = this.tenants.filter(
        item => item.name.toLowerCase().includes(searchString.toLowerCase())
    );
  }

  redirect(page) {
    if (page === 'soil_iq') {
      this.openSoilIQ();
      return;
    }
    this.managementService.userHashedPassword(this.email).subscribe(hashPassword => {
      if (hashPassword != null) {
        var mapForm = document.createElement("form");
        mapForm.target = "_blank";
        mapForm.method = "POST";
        mapForm.action = "https://app.precisiongateway.co.za/SGSPrecisionGateway/faces/RedirectRequest";

        var mapInput = document.createElement("input");
        mapInput.type = "hidden";
        mapInput.name = "email";
        mapInput.setAttribute("value", this.email);
        mapForm.appendChild(mapInput);

        var mapInput = document.createElement("input");
        mapInput.type = "hidden";
        mapInput.name = "password";
        mapInput.setAttribute("value", hashPassword.password);
        mapForm.appendChild(mapInput);

        var mapInput = document.createElement("input");
        mapInput.type = "hidden";
        mapInput.name = "page";
        mapInput.setAttribute("value", page);
        mapForm.appendChild(mapInput);

        document.body.appendChild(mapForm);
        mapForm.submit();
      }
    })
  }

  async logout() {
    await this.auth.logout(true);
    // await sNav.close();
  }

  // ngOnInit() {
  //   // this.refreshTenantList();
  //
  //   if (sessionStorage.getItem("selectedTenant") != null) {
  //     this.tenantIdSubject.next(+sessionStorage.getItem("selectedTenant"));
  //
  //     this.tenantId$.subscribe(id => {
  //       this.tenantId = id;
  //     })
  //
  //     // sessionStorage.removeItem('lastFarmId');
  //     // sessionStorage.removeItem('lastFarmName');
  //   }
  //
  //   //sessionStorage.setItem("selectedTenant", this.tenantId.toString());
  //   // this.tenantIdSubject.next(this.tenantId);
  //   // this.dashboard = this.translate.instant('NAV-BAR.DASHBOARD');
  //   // this.mapAnalysis = this.translate.instant('NAV-BAR.MAP-ANALYSIS');
  //   // this.fieldAdmin = this.translate.instant('NAV-BAR.FIELD-ADMIN');
  //   // this.priorityGroups = this.translate.instant('NAV-BAR.PRIOTITY-GROUPS');
  // }

  ngOnInit() {
    const savedTenant = sessionStorage.getItem("selectedTenant");
    if (savedTenant) {
      this.tenantIdSubject.next(+savedTenant);
      this.tenantId$.subscribe(id => {
        this.tenantId = id;
      })
    }
    this.auth.roles$.pipe(
        filter(roles => roles != null && roles.length > 0)
    ).subscribe(roles => {
      this.roles = roles;
      sessionStorage.setItem("roles", JSON.stringify(roles));
      this.mainRoutes = [];
      this.loadNavListItems(roles);
    });

    if (sessionStorage.getItem("roles") && !this.auth.rolesSubject.getValue()?.length) {
      this.auth.rolesSubject.next(JSON.parse(sessionStorage.getItem("roles")));
    }
  }

  switchTenant() {
    if (sessionStorage.getItem("selectedTenant") != null) {
      this.tenantIdSubject.next(+sessionStorage.getItem("selectedTenant"));
      this.filteredTenants = this.tenants;

      this.tenantId$.subscribe(id => {
        this.tenantId = id;
      })
    }
    // this.tenantId$.subscribe(id => {
    //   this.tenantId = id;
    // })
  }

  openedChange(opened: boolean) {
    if (!opened) {
      this.filteredTenants = this.tenants;
    }

    this.isSelectVisible = opened;
  }

  menuDisabled() {
    this.openSnackBar(this.translate.instant("MAPPING.FINISH-EDITING"), this.translate.instant("SNACKBAR.DISMISS"));
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 5000,
    });
  }

  // setLanguage(locale) {
  //   this.siteLocale = locale;
  //   this.siteLanguage = this.languageList.find(f => f.code === this.siteLocale).label;

  //   this.base.setLanguage(this.siteLocale);
  //   this.translate.use(locale);
  // }

  homeBtn() {
      this.toggleLoading(true);
     if (this.router.url !== '/tenant-view') {
        
      this.router.navigate(['tenant-view'], {relativeTo: this.route});
         
        setTimeout(() => {
          this.toggleLoading(false);
      }, 2000);
    } else {
         this.setBounds();
         this.toggleLoading(false);
    }

// alternate way to refresh tenant list - Removed for now need to update  retain last selected tenant as well
//     this.refreshTenantList();
  }

  async openSoilIQ() {
    const session = await this.auth.getCurrentSession();
    const accessToken = session.tokens?.accessToken?.toString();
    const idToken = session.tokens?.idToken?.toString();
    if (accessToken && idToken && this.tenantId) {
      window.open(`${this.soilIqUrl}/?access_token=${accessToken}&id_token=${idToken}&tenant_id=${this.tenantId}`, '_blank');
    }
  }

  setBounds() {
    this.tenantFarmBoundsService.fitBounds();
  }


  // refreshTenantList() {
  //   if(sessionStorage.getItem('user') !== null) {
  //     let userTemp = JSON.parse(sessionStorage.getItem('user'));
  //     if(userTemp.id !== null) {
  //
  //       // clear tenant list on refresh
  //       if (this.router.url === '/tenant-view') {
  //         window.addEventListener('visibilitychange', function(e) {
  //           if (document.visibilityState === 'hidden') {
  //             sessionStorage.removeItem('tenants');
  //           }
  //         });
  //       }
  //
  //       setTimeout(() => {
  //         this.managementService.getUserTenants(userTemp.id).subscribe((tenants) => {
  //           tenants.sort((a, b) => a.name.localeCompare(b.name));
  //           this.auth.tenantsSubject.next(tenants);
  //           let jsonTenants = JSON.stringify(tenants);
  //           sessionStorage.setItem("tenants", jsonTenants);
  //         });
  //       }, 1000);
  //     }
  //
  //   }
  //
  //
  // }

  private refreshTenantList(): void {
    const userRaw = sessionStorage.getItem('user');
    if (!userRaw) return;
    const userTemp = JSON.parse(userRaw);
    if (!userTemp?.id) return;

    setTimeout(() => {
      this.managementService.getUserTenants(userTemp.id).subscribe(tenants => {
        tenants.sort((a, b) => a.name.localeCompare(b.name));
        this.tenants = tenants;
        this.filteredTenants = tenants;
        sessionStorage.setItem("tenants", JSON.stringify(tenants));
        this.auth.tenantsSubject.next(tenants);

        const savedTenantId = sessionStorage.getItem("selectedTenant");
        if (savedTenantId) {
          // Restore the previously selected tenant without re-emitting
          this.tenantId = +savedTenantId;
        } else {
          // No tenant selected yet, default to home tenant
          const home = tenants.find(t => t.isHomeTenant);
          if (home) {
            sessionStorage.setItem("selectedTenant", home.id.toString());
            this.tenantIdSubject.next(home.id);
            this.tenantId = home.id;
          }
        }
      });
    }, 1000);
  }

  ngAfterViewInit() {
    //after page refresh - reload tenant list
    this.refreshTenantList();
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
    this.auth.logout();
  }

  protected readonly user = user;
}
